import { useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Box, Button, Grid, Typography, IconButton, Paper, CircularProgress } from "@mui/material";
import { AddCircle, Delete, UploadFile } from "@mui/icons-material";
import { GetAllResourcesRevisiones } from "../../../../hooks/partesRevisiones";
import { ImageViewer } from "../../../../components/FileDropper/imageViewer";



const AyudasVisualesProductos = ({ id_part }) => {

  const apiResources = useSelector((state) => state.app.apiResources);
  const { isLoading, isError, data, refetch } = GetAllResourcesRevisiones(id_part);
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (imageUrl) => {
    let resUrl = `${apiResources}/${imageUrl}`
    setSelectedImage(resUrl);
    setOpenImage(true);
  }

  const handleCloseImage = () => {
    setOpenImage(false);
    setSelectedImage(null);
  }

  const handleOpenPDF = (pdfUrl) => {
    // let resUrl = `${apiResources}/${pdfUrl}`
    let resUrl = `https://docs.google.com/gview?url=${encodeURIComponent(`${apiResources}/${pdfUrl}`)}`;
    window.open(resUrl, '_blank');
  };

  return (
    <Grid container spacing={0}>
      {
        !isLoading && data?.length > 0 &&
        <>
          {
            data?.map((res) => (
              <Grid item xs={6} sm={4} md={3} key={`res_rev_${res?.recu_id}`} sx={{ p: 2 }}>
                <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', width: '100%' }}>
                  {res.recu_mime.startsWith('image') ? (
                    <Box
                      component="img"
                      src={`${apiResources}/${res?.recu_ruta}`}
                      alt={res?.recu_nombre}
                      sx={{
                        width: 60,
                        height: 60,
                        objectFit: 'cover',
                        mr: 2,
                        borderRadius: 1,
                      }}
                      onClick={() => handleImageClick(res?.recu_ruta)}
                    />
                  ) : (
                    <Box
                      sx={{
                        minWidth: 60,
                        height: 60,
                        mr: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'grey.200',
                        borderRadius: 1,
                      }}
                      onClick={() => handleOpenPDF(res?.recu_ruta)}
                    >
                      <UploadFile />
                    </Box>
                  )}
                  <Box sx={{ width: '60%' }}>
                    <Typography noWrap sx={{ flexGrow: 1 }}>{res?.recu_nombre}</Typography>
                    <Typography noWrap sx={{ flexGrow: 1 }}>Revisión:</Typography>
                    <Typography noWrap sx={{ flexGrow: 1 }}>{res?.partes_revisiones?.pare_nombre}</Typography>
                  </Box>
                </Paper>
              </Grid>
            ))
          }
        </>
      }
      {
        isLoading &&
        <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
          <CircularProgress />
        </Grid>
      }
      {
        data?.length === 0 &&
        <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center' }} >
          <Alert severity="warning" sx={{ width: '100%' }}>No existen archivos en esta revisión</Alert>
        </Grid>
      }
      {isError &&
        <Grid item xs={12} sx={{ p: 0, mt: 3, display: 'flex', alignItems: 'center' }} >
          <Alert severity="error" sx={{ width: '100%' }}>No se pudieron cargar los archivos</Alert>
        </Grid>
      }
      {
        openImage && selectedImage &&
        <ImageViewer
          key={`image_viewer_${id_part}`}
          open={openImage}
          handleClose={handleCloseImage}
          selectedImage={selectedImage}
        />
      }
    </Grid>
  )

}


export default AyudasVisualesProductos;